import request from "@/utils/request"
import {deepClone} from "@/utils/index"

const state = {
    task:[],
    msg:{},
    msg_total:0,
    msg_page:1,
    msg_size:15,
    msg_unread:0
}

const mutations = {
    SET_MSG:(state,[data,page,total])=>{
        state.msg[page] = data;
        state.msg_page = page;
        state.msg_total = total;
    },
    ADD_MSG:(state,data)=>{
        state.msg[state.msg_page].push(data);
        state.msg_total += 1;
    },
    //刷新列表
    REFRESH_MSG:(state)=>{
        for(let obj in state.msg){
            obj = parseInt(obj);
            if(typeof state.msg[obj] == "undefined" || !state.msg[obj]){
                break;
            }
            if(state.msg[obj].length > state.msg_size){
                for(let i = 0;i<(state.msg[obj].length-state.msg_size);i++){
                    if(typeof state.msg[obj+1] == "undefined"){
                        state.msg[obj+1] = [];
                    }
                    state.msg[obj+1].push(state.msg[obj].pop());
                }
            }else if(state.msg[obj].length < state.msg_size && typeof state.msg[obj+1] != "undefined" && state.msg[obj+1].length){
                for(let i=0;i<(state.msg_size-state.msg[obj].length);i++){
                    state.msg[obj].push(state.msg[obj+1].shift());
                }
                if(state.msg[obj+1].length == 0){
                    delete state.msg[obj+1];
                }
            }
        }
    },
    DEL_MSG:(state,ids)=>{
        for(let i = state.msg[state.msg_page].length - 1 ;i >= 0;i-=1){
            if(ids.indexOf(state.msg[state.msg_page][i].id) != -1){
                state.msg[state.msg_page].splice(i,1);
                state.msg_total -= 1;
            }
        }
    },
    SET_UNREAD:(state,num)=>{
        state.msg_unread = parseInt(num);
    }
}

const actions = {

    get_msg({commit,state},page = false){
        return new Promise((resolve, reject)=>{
            if(!page){
                page = 1;
            }else{
                page = parseInt(page);
            }
            let data = {
                pageNum:page,
                pageSize:state.msg_size
            };
            if(typeof state.msg[page] != "undefined" && state.msg[page] && state.msg[page].length){
                resolve([state.msg[page],state.msg_total,state.msg_unread]);
            }else{
                request.post("message/list",data).then(res=>{
                    state.msg_unread = res.data.unread;
                    commit("SET_MSG",[res.data.data.list,page,res.data.data.total]);
                    commit("REFRESH_MSG");
                    resolve([state.msg[page],state.msg_total,state.msg_unread]);
                }).catch(err=>{
                    reject(err);
                });
            }
        });
    },

    del_msg({commit,state},ids){
        let url = "message/delete";
        return new Promise((resolve, reject)=>{
            request.post(url,{ids:ids}).then(res=>{
                commit("DEL_MSG",ids);
                commit("REFRESH_MSG");
                commit("SET_UNREAD",res.data);
                resolve(res);
            }).catch(err=>{
                reject(err);
            });
        });
    },
    set_unread({commit,state},num){
        commit("SET_UNREAD",num);
    }


}



export default {
    namespaced: true,
    state,
    mutations,
    actions
}
